import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper.jsx";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader.jsx";
import Deposit from "../../../../modules/Account/components/Deposit";
import { useDispatch } from "react-redux";
import { depositCreateMobileAction, getDepositSurveyStartAction } from "../../../../modules/Account/accountActions";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { useCallback } from "react";
import { openMobileSliderPageAction } from "../../../mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../mobileSliderPagesConstants";

function SlideMobileDeposit() {
    const {getLangPath} = useLangContext();

    const dispatch = useDispatch();

    const handleDepositQRCodeUnMount = useCallback(() => {
        dispatch(getDepositSurveyStartAction({
            onShowDepositSurvey: () => dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.DEPOSIT_SURVEY)),
        }));
    }, [dispatch]);

    const handleDepositCreate = useCallback((payload) => {
        dispatch(depositCreateMobileAction(payload));
    }, [dispatch]);

    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader>
            <h4 className="mb-0 text-center f16">{getLangPath('lite_version.home.top_up')}</h4>
        </MobileSliderPagesHeader>
        <Deposit
            depositCreate={handleDepositCreate}
            isSelectMethodSlider
            isDepositQRCodeSlider
            onDepositQRCodeUnMount={handleDepositQRCodeUnMount}
        />
    </MobileSliderPagesWrapper>
}

export default SlideMobileDeposit;
